import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { ThemeTokens } from '@repo/types';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 30 minutes frontend cache for theme query
const CACHE_TIME = 30 * 60 * 1000;

export const useThemeQuery = () => {
  const { apiUrl } = useGlobalContext();

  return useQuery({
    queryKey: ['theme', apiUrl],
    queryFn: () => fetchTheme(apiUrl),
    staleTime: CACHE_TIME,
    enabled: !!apiUrl,
  });
};

const fetchTheme = async (apiUrl: string): Promise<ThemeTokens | null> => {
  const { data } = await axios.get<ThemeTokens | null>(`${apiUrl}${API.endpoints.themeSettings}`);
  return data;
};
